<div class="top-section">
  <div class="timer-section">
    <div class="progress-container">
      <!-- Layout 1: Vertical (when itemsLength > 0) -->
      <ng-container *ngIf="itemsLength > 0; else horizontalLayout">
        <!-- Row 1: Items count and Timer -->
        <div class="header-row">
          <div class="items-header">
            <span style="font-size: 14px; font-weight: 600;">Items {{currentIndex + 1}} of {{itemsLength}}</span>
          </div>
          <span class="timer-pill">TIMER {{ formatTime(workDuration) }}</span>
        </div>
        
        <!-- Row 2: Progress Bar (full width) -->
        <div class="progress-bar-wrapper">
          <progress class="progress-bar" [value]="progress" max="100"></progress>
          <span class="progress-percent">{{ progress }}%</span>
        </div>
      </ng-container>
      
      <!-- Layout 2: Horizontal (when itemsLength is 0 or not provided) -->
      <ng-template #horizontalLayout>
        <div class="horizontal-layout">
          <div class="progress-bar-wrapper">
            <progress class="progress-bar" [value]="progress" max="100"></progress>
            <span class="progress-percent">{{ progress }}%</span>
          </div>
          <span class="timer-pill">TIMER {{ formatTime(workDuration) }}</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>